import { BaseControl } from "../base-control";

class EmailControlCtrl extends BaseControl {
  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
  }

  getMaxLength() {
    return this.token.control.maxLength;
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/email-control/email-control.component.html",
  controller: EmailControlCtrl
};